import { h, render } from 'preact';
import { initFrameAndPoll } from '@newswire/frames';

import data from '../../../data/data.json';
import RGVPartyBarChart from '../components/RGVPartyBarChart';

const rgvData = data['rgv'];

const YEARS = [
  { year: 2018, label: 'U.S. Senate' },
  { year: 2020, label: 'Presidential' },
  { year: 2022, label: 'Governor' },
  { year: 2024, label: 'Presidential' },
  { year: 2026, label: 'U.S. Senate' },
];

// Aggregate all 4 counties for each year
const aggregated = YEARS.map(({ year, label }) => {
  const demKey = `Dem total ${year}`;
  const gopKey = `GOP total ${year}`;
  const regKey = `Registered ${year}`;

  return {
    year,
    label,
    dem: rgvData.reduce((sum, county) => sum + (county[demKey] || 0), 0),
    gop: rgvData.reduce((sum, county) => sum + (county[gopKey] || 0), 0),
    registered: rgvData.reduce((sum, county) => sum + (county[regKey] || 0), 0),
  };
});

const maxValue = 115000;

render(
  <div id="rgv-charts-container" class="five-column">
    {aggregated.map((yearData, i) => (
      <RGVPartyBarChart
        yearData={yearData}
        maxValue={maxValue}
        showYAxis={i === 0}
      />
    ))}
  </div>,
  document.getElementById('rgv-party-comparison')
);

initFrameAndPoll(200);

if (process.env.NODE_ENV === 'development') {
  require('preact/debug');
}
